import {
  FETCH_NDT_ANALYTICS,
  FETCH_NDT_ANALYTICS_SUCCESS,
  FETCH_NDT_ANALYTICS_FAILURE,
  FETCH_AI_INSIGHTS,
  FETCH_AI_INSIGHTS_SUCCESS,
  FETCH_AI_INSIGHTS_FAILURE,
  CLEAR_NDT_ANALYTICS
} from './types';

const initialState = {
  data: null,
  filters: null,
  aiInsightsData: null,
  isFetching: false,
  isFetchingAIInsights: false,
  error: null,
  aiInsightsError: null
};

const ndtAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NDT_ANALYTICS:
      return {
        ...state,
        isFetching: true,
        error: null
      };

    case FETCH_NDT_ANALYTICS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.payload?.data || action.payload,
        filters: action.payload?.data?.metadata?.filters || action.payload?.metadata?.filters || null
      };

    case FETCH_NDT_ANALYTICS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        data: null,
        filters: null
      };

    case FETCH_AI_INSIGHTS:
      return {
        ...state,
        isFetchingAIInsights: true,
        aiInsightsError: null
      };

    case FETCH_AI_INSIGHTS_SUCCESS:
      return {
        ...state,
        isFetchingAIInsights: false,
        aiInsightsError: null,
        aiInsightsData: action.payload?.data || action.payload
      };

    case FETCH_AI_INSIGHTS_FAILURE:
      return {
        ...state,
        isFetchingAIInsights: false,
        aiInsightsError: action.error,
        aiInsightsData: null
      };

    case CLEAR_NDT_ANALYTICS:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default ndtAnalyticsReducer;

